$w.onReady(function () {
    // Inject Google Font Lobster using a standard script element
    let linkTag = `<link href="https://fonts.googleapis.com/css2?family=Lobster&display=swap" rel="stylesheet">`;

    // Define CSS styles for headings and body text
    let customCSS = `
        <style>
            h1, h2, h3 {
                font-family: 'Lobster', cursive !important;
                font-size: 28px;
                line-height: 1.4;
                letter-spacing: 1px;
                text-transform: capitalize;
            }

            body, p, span, div {
                font-family: 'Lobster', cursive !important;
                font-size: 16px;
                line-height: 1.6;
                letter-spacing: 0.5px;
                font-weight: 400;
            }

            @media screen and (max-width: 768px) {
                body, p, span, div {
                    font-size: 14px;
                    line-height: 1.5;
                    letter-spacing: 0.3px;
                }

                h1, h2, h3 {
                    font-size: 24px;
                }
            }
        </style>
    `;

    // Append font and styles dynamically using a hidden HTML iframe trick
    let iframe = document.createElement("iframe");
    iframe.style.display = "none";
    document.body.appendChild(iframe);

    let iframeDoc = iframe.contentWindow.document;
    iframeDoc.open();
    iframeDoc.write(linkTag + customCSS);
    iframeDoc.close();

    console.log("Lobster font applied successfully!");
});